/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from "react";
import { styled, theme } from "../theme/theme";

export interface IconProps {
  size?: "xx-small" | "x-small" | "small" | "medium" | "large" | "xl" | "xxl";
  variant?: "avatar" | "default";
}

export interface ImageIconProps extends IconProps {
  image: string;
  margin?: string;
}

interface CssProps extends IconProps {
  borderRadius: string;
  boxShadow: string;
  diameter?: string;
  disabledImageUrl?: string;
  hoverState?: string;
  imageUrl?: string;
  isDisabled?: boolean;
  margin?: string;
}

export const Icon: React.FunctionComponent<IconProps> = styled.span.attrs<IconProps>(
  (props) => {
    let diameter = theme.iconDiameters.m;
    if (props.size === "xx-small") {
      diameter = theme.iconDiameters.xxs;
    }
    if (props.size === "x-small") {
      diameter = theme.iconDiameters.xs;
    }
    if (props.size === "small") {
      diameter = theme.iconDiameters.s;
    }
    if (props.size === "large") {
      diameter = theme.iconDiameters.l;
    }
    if (props.size === "xl") {
      diameter = theme.iconDiameters.xl;
    }
    if (props.size === "xxl") {
      diameter = theme.iconDiameters.xxl;
    }

    return {
      diameter,
      borderRadius: props.variant === "avatar" ? "50%" : 0,
      boxShadow:
        props.variant === "avatar"
          ? "0px 2px 4px rgba(46, 53, 56, 0.25)"
          : "none",
    };
  }
)<CssProps>`
  background-image: url(${(props) => {
    return props.imageUrl;
  }});
  background-size: cover;
  height: ${(props) => {
    return props.diameter;
  }};
  width: ${(props) => {
    return props.diameter;
  }};
  display: inline-block;
  border-radius: ${(props) => {
    return props.borderRadius;
  }};
  box-shadow: ${(props) => {
    return props.boxShadow;
  }};
`;

export const ImageIcon: React.FunctionComponent<ImageIconProps> = styled(
  Icon
).attrs<ImageIconProps>((props) => {
  return { imageUrl: props.image, margin: props.margin };
})<CssProps>`
  background-image: url(${(props) => {
    return props.imageUrl;
  }});
  background-repeat: no-repeat;
  margin: ${(props) => {
    return props.margin;
  }};
`;
